export const loanDrilldownSidebarTypes = {
  CREATE_NEW: "createNew",
  FILE_PREVIEW: "filePreview",
  FILE_UPLOAD: "fileUpload",
  SIZER_UPLOAD: "sizerUpload",
  FORMSPY: "formSpy",
  COMMENTS: "comments",
  ADD_BORROWER: "addBorrower",
  EDIT_BORROWER: "editBorrower",
  ADD_LOAN_RELATED_CONTACT: "addLoanRelatedContact",
  ADD_PROPERTY: "addProperty",
  ADD_EXCEPTION: "addLoanException",
  ADD_LOAN_FEE: "addLoanFee",
  ADD_LOAN_CREDIT: "addLoanCredit",
  ADD_LOAN_ESCROW_ITEM: "addLoanEscrowItem",
  ADD_DRAW: "addDraw",
  ADD_LOAN_SPECIAL_CONDITION: "addLoanSpecialCondition",
  ADD_EDIT_CORRESPONDENT_FEE: "addEditCorrespondentFee",
  ADD_EDIT_BROKER_TERMS: "addEditBrokerTerms",
  ADD_EDIT_THIRD_PARTY_FEES: "addEditThirdPartyFees",
  ADD_EDIT_ENTITY: "addEditEntity",
  ADD_EDIT_ENTITY_MEMBER: "addEditEntityMember",
  ADD_EDIT_LOAN_CONDITION: "addEditLoanCondition",
  ADD_EDIT_LOAN_CONDITION_REDESIGN: "addEditLoanConditionRedesign",
  ADD_EDIT_LIQUIDITY_SOURCE: "addEditLiquiditySource",
  ADD_EDIT_DSCR_INCOME_SOURCE: "addEditDscrIncomeSource",
  ADD_EDIT_DSCR_EXPENSE_SOURCE: "addEditDscrExpenseSource",
  // The redesign tab's row drawer (income + expense in one type; the state's
  // `bucket` decides the anatomy). Only the DSCR Workbook redesign opens it.
  DSCR_ROW_REDESIGN: "dscrRowRedesign",
  ADD_EDIT_LOAN_LOCK: "addEditLoanLock",
  ORDER_FLOOD_CERT: "orderFloodCert",
  ORDER_FUNDING_SHIELD: "orderFundingShield",
  ORDER_INTERNAL_APPRAISAL: "orderInternalAppraisal",
  // Secondary valuation ordered through an outside vendor / AMC (Orders tab).
  ORDER_OUTSIDE_VALUATION: "orderOutsideValuation",
  UW_NOTES: "uwNotes",
  PROCESSING_NOTES: "processingNotes",
  UW_CHECKLIST: "uwChecklist",
  UW_STIPS_AND_CONDITIONS: "uwStipsAndConditions",
  KEY_DATES_AND_TOTALS: "keyDatesAndTotals",
  LOAN_CHANGE_HISTORY: "loanChangeHistory",
  EMAIL_COMPOSER: "emailComposer",
  DOCUMENTS: "documents",
  DOCUMENT_UPLOAD_PICKER: "documentUploadPicker",
};
